import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a1b8bcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tips" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left-tip" }, "温馨提示", -1))
const _hoisted_4 = { class: "left-center-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "right-phone" }, "服务电话"),
  /*#__PURE__*/_createElementVNode("span", { class: "right-center" }, "0580-38889090")
], -1))

import { getNotice } from '@/service/modules/star'
import { onMounted, ref } from 'vue'


import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'index',
  setup(__props) {

const notice = ref('')
const getTipNotice = async () => {
  const res = await getNotice()
  if (res.code === 200) {
    notice.value = res.data
  } else {
    ElMessage.error('请求失败，' + res.message)
  }
}
// getTipNotice()

const centerRef = ref()
const itemsRef = ref()

const duration = ref('')
const flag = ref(true)
const handleMouseEnter = () => {
  if (flag.value) {
    itemsRef.value.style.animationPlayState = 'paused'
  }
}

const handleMouseLeave = () => {
  if (flag.value) {
    itemsRef.value.style.animationPlayState = 'running'
  }
}
onMounted(() => {
  if (notice.value) {
    const scrollWidth = itemsRef.value.scrollWidth
    const width = centerRef.value.offsetWidth
    const time = scrollWidth / 100 // 设置滚动速度，每秒滚动50px
    duration.value = `${time}s`
  }

  // if (scrollWidth > width) {

  // } else {
  //   itemsRef.value.style.animationPlayState = 'paused'
  //   flag.value = false
  // }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "left-center",
        ref_key: "centerRef",
        ref: centerRef
      }, [
        (notice.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "left-center-items",
              ref_key: "itemsRef",
              ref: itemsRef,
              style: _normalizeStyle({ 'animation-duration': duration.value }),
              onMouseenter: handleMouseEnter,
              onMouseleave: handleMouseLeave
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(notice.value), 1)
            ], 36))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _hoisted_5
  ]))
}
}

}